const SCALES = {
  A: {
    FG_PALLET: 2.1,
    BG_PALLET: 2.5,
    FG_MOVE_REZ: 0.01,
    BG_MOVE_REZ: 0.01,
    FG_SCALE: 3,
    BG_SCALE: 0.01,
    FG_ROTATE: 0.01,
    BG_ROTATE: 0.001,
  },
  B: {
    FG_PALLET: 1.1,
    BG_PALLET: 1.5,
    FG_MOVE_REZ: 0.1,
    BG_MOVE_REZ: 0.01,
    FG_SCALE: 1.5,
    BG_SCALE: 0.1,
    FG_ROTATE: 0.1,
    BG_ROTATE: 0.01,
  },
  C: {
    FG_PALLET: 4,
    BG_PALLET: 2.5,
    FG_MOVE_REZ: 0.01,
    BG_MOVE_REZ: 0.1,
    FG_SCALE: 0.5,
    BG_SCALE: 2.1,
    FG_ROTATE: 0.5,
    BG_ROTATE: 0.1,
  },
  D: {
    FG_PALLET: 2,
    BG_PALLET: 5,
    FG_MOVE_REZ: 2.1,
    BG_MOVE_REZ: 0.01,
    FG_SCALE: 5,
    BG_SCALE: 0.1,
    FG_ROTATE: 0.05,
    BG_ROTATE: 0.01,
  }
}

export default SCALES
